module.exports = __webpack_public_path__ + "img/sbl0005.e7fd4da0.png";